/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Datasets_Card_ColumnsInputs */



/**
* | output |
* | --- |
* | "{count} columns" |
*
* @param {Datasets_Card_ColumnsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_card_columns = /** @type {((inputs: Datasets_Card_ColumnsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Card_ColumnsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Spalten`)
	return /** @type {LocalizedString} */ (`${i?.count} columns`)
});